export default "__VITE_ASSET__DaKazJHS__"